import Vue from 'vue';
import moment from 'moment';

const periods = ['Today', 'Yesterday', 'Week', 'Last-week', 'Month', 'Last-month', 'MTD',];

function getRanges () {
  return [{
    label: 'Today',
    range: [moment(), moment()]
  }, {

    label: 'Yesterday',
    range: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
  }, {
    label: 'Last 7 Days',
    range: [moment().subtract(6, 'days'), moment()],
  }, {
    label: 'Last 30 Days',
    range: [moment().subtract(29, 'days'), moment()]
  }, {
    label: 'This Month',
    range: [moment().startOf('month'), moment().endOf('month')]
  }, {
    label: 'Last Month',
    range: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }];
}

function getFutureRanges () {
  return [{
    label: '2 days',
    range: [moment(), moment().add(1, 'days')],
  }, {
    label: '7 days',
    range: [moment(), moment().add(6, 'days')],
  }, {
    label: '30 days',
    range: [moment(), moment().add(29, 'days')],
  },

  ];
}

function getNetTermsRanges () {
  return [{
    label: '30 days',
    range: [moment(), moment().add(29, 'days')],
  }, {
    label: '60 days',
    range: [moment(), moment().add(59, 'days')],
  }, {
    label: '90 days',
    range: [moment(), moment().add(89, 'days')],
  },

  ];
}

const dayFormat = 'YYYY-MM-DD';

function periodToDateFrom (period, defaultValue) {
  switch (period) {
    case 'Today':
      return Vue.moment();
    case 'Yesterday':
      return Vue.moment().subtract(1, 'days');
    case 'Last 7 Days':
      return moment().subtract(6, 'days');
    case 'Last 30 Days':
      return moment().subtract(29, 'days');
    case 'Week':
      return Vue.moment().startOf('isoWeek');
    case 'Last-week':
      return Vue.moment().subtract(1, 'week').startOf('isoWeek');
    case 'Month':
    case 'This Month':
      return Vue.moment().startOf('month');
    case 'Last-month':
    case 'Last Month':
      return Vue.moment().subtract(1, 'month').startOf('month');
    case 'Total':
      return Vue.moment('2018-12-31', 'YYYY-MM-DD');
    case 'MTD':
      return Vue.moment().startOf('month');
  }

  if (defaultValue) {
    return defaultValue;
  }

  return Vue.moment();
}

function periodToDateTo (period, defaultValue) {
  switch (period) {
    case 'Today':
      return Vue.moment();
    case 'Yesterday':
      return Vue.moment().subtract(1, 'days');
    case 'Last 7 Days':
      return moment();
    case 'Last 30 Days':
      return moment();
    case 'Week':
      return Vue.moment().endOf('isoWeek');
    case 'Last-week':
      return Vue.moment().subtract(1, 'week').endOf('isoWeek');
    case 'Month':
    case 'This Month':
      return Vue.moment().endOf('month');
    case 'Last-month':
    case 'Last Month':
      return Vue.moment().subtract(1, 'month').endOf('month');
    case 'MTD':
    case 'Total':
      return Vue.moment();
  }

  if (defaultValue) {
    return defaultValue;
  }

  return Vue.moment();
}

function datesToPeriod (from, to) {
  const today = moment().format(dayFormat);
  const yesterday = moment().subtract(1, 'day').format(dayFormat);

  if (from === to) {
    if (from === today) {
      return 'Today';
    }
    if (from === yesterday) {
      return 'Yesterday';
    }
  }

  if (to === today) {
    if (from === moment().subtract(6, 'day').format(dayFormat)) {
      return 'Last 7 Days';
    }
    if (from === moment().subtract(29, 'day').format(dayFormat)) {
      return 'Last 30 Days';
    }

  }

  if (from === moment().startOf('month').format(dayFormat) && to === moment().endOf('month').format(dayFormat)) {
    return 'This Month';
  }

  if (from === moment().subtract(1, 'month').startOf('month').format(dayFormat) && to === moment().subtract(1, 'month').endOf('month').format(dayFormat)) {
    return 'Last Month';
  }

  return from + ' - ' + to; //'Custom Range';
}

function prevPeriodToDateTo (period) {
  switch (period) {
    case 'Today':
      return periodToDateTo('Yesterday');
    case 'Yesterday':
      return Vue.moment().subtract(2, 'days');
    case 'Week':
      return periodToDateTo('Last-week');
    case 'Last-week':
      return Vue.moment().subtract(2, 'week').endOf('isoWeek');
    case 'Month':
      return periodToDateTo('Last-month');
    case 'Last-month':
      return Vue.moment().subtract(2, 'month').endOf('month');
    case 'MTD':
      return Vue.moment().subtract(1, 'month');
    case 'Total':
    default:
      return Vue.moment();
  }
}

function prevPeriodToDateFrom (period) {
  switch (period) {
    case 'Today':
      return periodToDateFrom('Yesterday');
    case 'Yesterday':
      return Vue.moment().subtract(2, 'days');
    case 'Week':
      return periodToDateFrom('Last-week');
    case 'Last-week':
      return Vue.moment().subtract(2, 'week').startOf('isoWeek');
    case 'Month':
      return periodToDateFrom('Last-month');
    case 'Last-month':
      return Vue.moment().subtract(2, 'month').startOf('month');
    case 'MTD':
      return Vue.moment().subtract(1, 'month').startOf('month');
    case 'Total':
    default:
      return Vue.moment();
  }
}

function calculatePrevPeriod (start, end) {
  const periodLength = end.diff(start, 'days');

  const startPrev = moment(start).subtract(periodLength + 1, 'days');

  const endPrev = moment(start).subtract(1, 'days');

  return [startPrev, endPrev];
}

export {
  periodToDateFrom, periodToDateTo, periods, prevPeriodToDateTo, prevPeriodToDateFrom, datesToPeriod, dayFormat, getRanges, calculatePrevPeriod, getFutureRanges, getNetTermsRanges
};
